import { useEffect } from "react";
import { warmKokoro } from "./browserVoice";
import { createKokoroWorker } from "./kokoroWorker";

/** How long after the app is on screen the voice starts, if the browser cannot say when it is idle. */
const FALLBACK_DELAY_MS = 3000;

/**
 * Downloads the coaching voice (Kokoro, ~90 MB, cached by the browser after the first visit) in the background from
 * whichever screen opens first, like PoseModelWarmup does for the pose model (owner, 2026-10-20), so it is ready when
 * a free clip's coaching is read out. It waits until the page is idle, so it never competes with the first paint or
 * the pose model's own download. Renders nothing; a failure is silent (the voicing retries on its first sentence).
 */
export default function VoiceModelWarmup() {
  useEffect(() => {
    const start = () => warmKokoro(createKokoroWorker);
    const w = window as any;
    if (typeof w.requestIdleCallback === "function") {
      const id = w.requestIdleCallback(start, { timeout: FALLBACK_DELAY_MS * 2 });
      return () => w.cancelIdleCallback?.(id);
    }
    const t = window.setTimeout(start, FALLBACK_DELAY_MS);
    return () => window.clearTimeout(t);
  }, []);
  return null;
}
